import { useEffect, useRef } from "preact/hooks";
import { Icon } from "../chrome/icons.js";
import { clockLabel } from "../clock.js";
import { shortName, type ViewPhoto } from "../photos.js";

export interface ViewerProps {
  readonly photos: readonly ViewPhoto[];
  readonly index: number;
  onIndex(index: number): void;
  onClose(): void;
}

export function Viewer({ photos, index, onIndex, onClose }: ViewerProps) {
  const start = useRef<number | null>(null);
  const step = (delta: number) => {
    const next = index + delta;
    if (next >= 0 && next < photos.length) {
      onIndex(next);
    }
  };
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      } else if (event.key === "ArrowLeft") {
        step(-1);
      } else if (event.key === "ArrowRight") {
        step(1);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });
  const photo = photos[index];
  if (!photo) {
    return null;
  }
  return (
    <div
      class="d-viewer"
      data-theme="dark"
      role="dialog"
      aria-modal="true"
      aria-label={`Foto de ${shortName(photo.author)}`}
      data-testid="viewer"
      onTouchStart={(event) => {
        start.current = event.touches[0]?.clientX ?? null;
      }}
      onTouchEnd={(event) => {
        const from = start.current;
        const to = event.changedTouches[0]?.clientX;
        start.current = null;
        if (from !== null && to !== undefined && Math.abs(to - from) > 48) {
          step(to < from ? 1 : -1);
        }
      }}
    >
      <img class="d-viewer-photo" src={photo.large} alt="" />
      <div class="d-viewer-top">
        <button type="button" class="d-icon-button" aria-label="Voltar" onClick={onClose}>
          <Icon name="chevronLeft" />
        </button>
        <p class="d-viewer-publisher" data-testid="viewer-publisher">
          {clockLabel(photo.at)} · {shortName(photo.author)}
        </p>
        <span />
      </div>
    </div>
  );
}
